module.exports = __webpack_public_path__ + "media/images/bet__correctMarker-0ff2068db82fecfe94a3ad6f64c60071.png";